"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageContentType = void 0;
var MessageContentType;
(function (MessageContentType) {
  MessageContentType["CHAT"] = "CHAT";
  // Only visible to Driftt users
  MessageContentType["PRIVATE_NOTE"] = "PRIVATE_NOTE";
  MessageContentType["CONVERSATION_EVENT"] = "CONVERSATION_EVENT";
  // Campaign created
  MessageContentType["NPS_QUESTION"] = "NPS_QUESTION";
  MessageContentType["NPS_RESPONSE"] = "NPS_RESPONSE";
  MessageContentType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
  MessageContentType["EMAIL_CAPTURE"] = "EMAIL_CAPTURE";
  MessageContentType["SUGGESTION"] = "SUGGESTION";
  MessageContentType["EDIT"] = "EDIT";
  MessageContentType["PRIVATE_PROMPT"] = "PRIVATE_PROMPT";
  MessageContentType["CHAT_RATING"] = "CHAT_RATING";
  MessageContentType["EMAIL_CAPTURE_CARD"] = "EMAIL_CAPTURE_CARD";
  MessageContentType["BOT_CONVERSATION_RATING"] = "BOT_CONVERSATION_RATING";
  MessageContentType["BOT_NODE_CONDITION_EVALUATION"] = "BOT_NODE_CONDITION_EVALUATION";
  // SMS Capture
  MessageContentType["SMS_NUMBER_REQUESTED"] = "SMS_NUMBER_REQUESTED";
  MessageContentType["SMS_NUMBER_SUCCESS"] = "SMS_NUMBER_SUCCESS";
})(MessageContentType = exports.MessageContentType || (exports.MessageContentType = {}));